import React, { useState, useEffect, useCallback } from 'react'
import TableInput from '../../../dpe-usco/components/Table/TableInput/TableInput'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Button } from 'syngenta-react-components'
import Select from '../../../dpe-usco/components/Select/Select'

const HARVEST_HEADER = [
  'Field Name',
  'Harvested Acres',
  'Harvest Date',
  'Yield per Acre',
  'Harvest',
  ' '
]

const options = [
  {
    id: 'bushels',
    value: 'bu'
  }, 
  { value: 'tons',
    id:'tons' 
  }
]

  


export const HarvestSteward = ({ isTotalfield, harvestData, updateRowData, modalCallBack, isActiveWidget, setIsActiveWidget, setHarvestData, replantOrLost, fieldCompleteOrNot }) => {
  const[isChecked, setIsChecked] = useState(false)
  const[firstRow, setFirstRow] = useState(0)
  const[summaryHarvest, setSummaryHarvest] = useState(0)
  const[summaryHarvestAcres, setSummaryHarvestAcres] = useState(0)
  const[summaryYieldAcres, setSummaryYieldAcres] = useState(0)
  const[isFieldAvailable, setIsFieldAvailable] = useState(false)
  const [harvestDataFormated, setHarvestDataFormated] = useState(harvestData)

  useEffect(()=> {
    if(harvestData.length > 0) {
      const formattedData = harvestData.map(item => {
        let formattedDate = item.harvest_date
        if (item.harvest_date.includes('T')) {
          formattedDate = item.harvest_date.split('T')[0]
        }
        return { ...item, harvest_date: formattedDate }
      })
      setHarvestDataFormated(formattedData)
    }
  },[harvestData])
  
  const commonFunction = useCallback(harvestDataArr => {
    let sumHarvest = 0
    let sumTotalAcres = 0
    harvestDataArr.forEach((data, index) => {
      if(!replantOrLost[index]?.fieldLost && !fieldCompleteOrNot[index]?.isDisable) {
        sumHarvest = (parseFloat(data.total_harvest?data.total_harvest:0) + parseFloat(sumHarvest)).toFixed(2)
        sumTotalAcres = (parseFloat(data.total_acres?data.total_acres:0) + parseFloat(sumTotalAcres)).toFixed(2)
      }
    })
    setSummaryHarvest(sumHarvest)
    setSummaryHarvestAcres(sumTotalAcres)
    setSummaryYieldAcres((sumHarvest/sumTotalAcres).toFixed(2))
  },[replantOrLost, fieldCompleteOrNot])

  const handleClickTotalAcre = (e,inx) => {
    const harvestDataArr = harvestData.map((data, index) => 
      ( index!==inx ? 
        { ...data } : 
        { ...data, 
          total_acres: e.target.value,
          yield_per_acre: (data.total_harvest / e.target.value).toFixed(2)
        } 
      )
    )
    setHarvestData(harvestDataArr)
    let sumTotalAcres = 0
    harvestDataArr.forEach((data, index) => {
      if(!replantOrLost[index]?.fieldLost && !fieldCompleteOrNot[index]?.isDisable) {
        sumTotalAcres = ((parseFloat(data.total_acres?data.total_acres:0)) + parseFloat(sumTotalAcres)).toFixed(2)
      }
    })
    setSummaryHarvestAcres(sumTotalAcres)
    commonFunction(harvestDataArr)
  }


  const handleClickHarvestDate = e => {
    if(harvestData.length){
      const harvestDataArr = harvestData.map((data, index) => ( (replantOrLost[index]?.fieldLost || fieldCompleteOrNot[index]?.isDisable) ? { ...data } : { ...data, harvest_date: e.target.value } ))
      setHarvestData(harvestDataArr)
    }
  }

  const handleClickYieldPerAcre = (e,inx) => {
    const harvestDataArr = harvestData.map((data, index) => 
      ( index!==inx ? 
        { ...data } : 
        { ...data, 
          yield_per_acre: e.target.value,
          total_harvest: (e.target.value * data.total_acres).toFixed(2)
        } 
      )
    )
    setHarvestData(harvestDataArr)
    commonFunction(harvestDataArr)
  }

  const handleClickHarvest = (e,inx) => {
    const harvestDataArr = harvestData.map((data, index) => 
      ( index!==inx ? 
        { ...data } : 
        { ...data, 
          yield_per_acre: (e.target.value / data.total_acres).toFixed(2),
          total_harvest: e.target.value
        } 
      )
    )
    setHarvestData(harvestDataArr)
    commonFunction(harvestDataArr)
  }

  const handleClickSummaryYPA = e => {
    setSummaryYieldAcres(e.target.value)
    const harvestDataArr = harvestData.map((data, index) => 
      ((!replantOrLost[index]?.fieldLost && !fieldCompleteOrNot[index]?.isDisable) ?
        { ...data, 
          yield_per_acre: e.target.value,
          total_harvest: (e.target.value * data.total_acres).toFixed(2)
        } :
        { ...data }
      )
    )
    setHarvestData(harvestDataArr)
    let sumHarvest = 0
    harvestDataArr.forEach((data, index) => {
      if(!replantOrLost[index]?.fieldLost && !fieldCompleteOrNot[index]?.isDisable) {
        sumHarvest = (parseFloat(data.total_harvest?data.total_harvest:0) + parseFloat(sumHarvest)).toFixed(2)
      }
    })
    setSummaryHarvest(sumHarvest)
  }

  const handleClickSummaryTotalHarvest = e => {
    setSummaryHarvest(e.target.value)
    let sumTotalAcres = 0
    harvestData.forEach((data, index) => {
      if(!replantOrLost[index]?.fieldLost) {
        sumTotalAcres = (parseFloat(data.total_acres?data.total_acres:0) + parseFloat(sumTotalAcres)).toFixed(2)
      }
    })
    let totalSummaryYield = (e.target.value/sumTotalAcres).toFixed(2)
    setSummaryYieldAcres(totalSummaryYield)

    const harvestDataArr = harvestData.map((data, index) => 
      ((!replantOrLost[index]?.fieldLost && !fieldCompleteOrNot[index]?.isDisable) ?
        { ...data, 
          yield_per_acre: totalSummaryYield,
          total_harvest: (totalSummaryYield * data.total_acres).toFixed(2)
        } :
        { ...data }
      )
    )
    setHarvestData(harvestDataArr)
  }

  useEffect(() => {
    if(replantOrLost.length > 0 && !isTotalfield ) {
      const mergeFileLostAndDisable = replantOrLost.map(data => {
        const indexOfDisable = fieldCompleteOrNot.findIndex(val => (val.id === data.field_id))
        return {
          ...data,
          isDisable: fieldCompleteOrNot[indexOfDisable]?.isDisable
        }
      })
    
      const isFieldAvailableIndex = mergeFileLostAndDisable.findIndex(data => !data?.isDisable && !data?.fieldLost)
      if(isFieldAvailableIndex === -1) {
        setIsFieldAvailable(false)
      } else {
        setIsFieldAvailable(true)
      }
      setFirstRow(isFieldAvailableIndex)
    }

  }, [replantOrLost, fieldCompleteOrNot, isTotalfield])

  const checked = e => {
    setIsChecked(prev => !prev)
    if(e.target.checked){
      const harvestDataArr = harvestData.map((data, index) => ( (replantOrLost[index]?.fieldLost || fieldCompleteOrNot[index]?.isDisable) ? { ...data } : { ...data, harvest_date: harvestData[firstRow].harvest_date } ))
      setHarvestData(harvestDataArr)
    }
  }

  const handleSelection = (option, event, index) => {
    setHarvestData(prev => {
      prev[index].unit_type = option.value
      return prev
    })
  }

  const mapHeaders = headerArray => {
    return headerArray.map(header => {
      return {
        value: header,
        format() {
          return headerCell(header)
        }
      }
    })
  }

  const headerCell = value => {
    return (
      <div key={value} className={`${value} cell`}>
        <div>{value}</div>
      </div>
    )
  }

  const footerData = {
    summary: 'Summary',
    summaryHarvestAcres: summaryHarvestAcres,
    harvestDate: true,
    summaryYieldPerAcres:isNaN(summaryYieldAcres)? 0 :summaryYieldAcres,
    summaryTotalHarvest:summaryHarvest,
    summaryUnit:true
  }
  
  const editFormat = {
    name: val => {
      return <div className='cell w100'>{val}</div>
    },
    total_acres: (val, onChange, index) => {
      return (
        <input
          placeholder='Total acres'
          aria-label='harvestAcres'
          className='cell interff'
          key='Acres'
          onChange={ e => handleClickTotalAcre(e,index)}
          type='number'
          value={val}
        />
      )
    },
    harvest_date: (val, onChange, index) => {
      return (
        <input
          role='grid'
          placeholder='mm/dd/yy'
          aria-label='harvestDate'
          className='cell interff'
          key='second'
          onChange={isChecked? e => handleClickHarvestDate(e):onChange}
          type='date'
          value={val}
          disabled ={isChecked && index !== firstRow ? true : false}
        />
      )
    },
    yield_per_acre: (val, onChange,index) => {
      return (
        <input
          placeholder='Yield per acre'
          aria-label='harvestYield'
          className='cell interff'
          key='plant_rate'
          onChange={ e => handleClickYieldPerAcre(e,index)}
          type='number'
          value={val}
        />
      )
    },
    total_harvest: (val, onChange, index) => {
      return (
        <input
          placeholder='Total harvest'
          aria-label='harvestTotal'
          className='cell interff ov'
          key='bushels'
          onChange={ e => handleClickHarvest(e,index)}
          type='number'
          value={val}
        />
      )
    },
    unit_type: (val, onChange, index) => {
      return (
        <div>
          <Select defaultId={val} options={options} handleSelection={handleSelection} index={index}/>
        </div>
      )
    },
    summary: val => {
      return <div className='cell w100'>Summary</div>
    },
    summaryHarvestAcres: val => {
      return <div className='cell w100'>{val}</div>
    },
    harvestDate: val => {
      return <div className='cell w100'></div>
    },
    summaryYieldPerAcres: val => {
      return (
        <input
          placeholder=''
          aria-label='summaryYieldPerAcres'
          className='cell interff'
          key='Acres'
          onChange={ e => handleClickSummaryYPA(e)}
          type='number'
          value={val}
        />
      )
    },
    summaryTotalHarvest: (val, onChange) => {
      return (
        <input
          placeholder=''
          aria-label='summaryTotalHarvest'
          className='cell interff'
          key='Acres'
          onChange={ e => handleClickSummaryTotalHarvest(e)}
          type='number'
          value={val}
        />
      )
    },
    summaryUnit: val => {
      return <div className='cell w100'></div>
    }
  }

  const defaultFormat = {
    name: true,
    harvest_date: true,
    total_acres: true,
    yield_per_acre_formatted: true,
    total_harvest_formatted: true,
    unit_type: true,
    summary: true,
    summaryHarvestAcres: true,
    harvestDate: true,
    summaryYieldPerAcres:true,
    summaryTotalHarvest:true,
    summaryUnit:true
  }

  const defaultDataKeys = [
    'name',
    'total_acres',
    'harvest_date',
    'yield_per_acre_formatted',
    'total_harvest_formatted',
    'unit_type',
    'summary',
    'summaryHarvestAcres',
    'harvestDate',
    'summaryYieldPerAcres',
    'summaryTotalHarvest',
    'summaryUnit'
  ]

  const editDataKeys = [
    'name',
    'total_acres',
    'harvest_date',
    'yield_per_acre',
    'total_harvest',
    'unit_type',
    'summary',
    'summaryHarvestAcres',
    'harvestDate',
    'summaryYieldPerAcres',
    'summaryTotalHarvest',
    'summaryUnit'
  ]


  const harvestStructure = {
    headers: mapHeaders(HARVEST_HEADER),
    dataKeys: defaultDataKeys,  
    customStyleId:{
      unit_type: `${isActiveWidget === 'HARVEST' ? 'overflow-visible' : 'c-white'}`
    },
    format: defaultFormat,
    footers: isTotalfield?null:footerData
  }

  if (isActiveWidget === 'HARVEST') {
    harvestStructure.format = editFormat
    harvestStructure.dataKeys = editDataKeys
  }
  
  useEffect(() => {
    if(!isActiveWidget)
      commonFunction(harvestData)
  },[isActiveWidget,harvestData,commonFunction])

  const clickHandler = () => {
    setIsChecked(false)
    setIsActiveWidget('HARVEST')
  }
  let buttons = (
    <Button disabled={(isActiveWidget && isActiveWidget !== 'HARVEST') || isTotalfield || !isFieldAvailable }  text='Edit harvest stewardship' clickHandler={clickHandler}/>)
  if (isActiveWidget === 'HARVEST'){
    buttons = (
      <div className='100% tar'>
        <Button customClassName='mr10' type='default' text='Cancel' clickHandler={() => modalCallBack('DISCARD')}/>
        <Button customClassName='mr10' type='success' text='Save' clickHandler={() => modalCallBack('HARVEST')}/>
      </div>)
  } 

  return(
    <Widget dataTestId='harvestStewardshipTable' title='Harvest Stewardship' button={buttons}>
      <TableInput updateRowData={updateRowData} structure={harvestStructure} data={harvestDataFormated} editMode={isActiveWidget === 'HARVEST'} replantOrLost={replantOrLost} fieldCompleteOrNot={fieldCompleteOrNot} fieldCompleteOrNotPage="harvest"></TableInput>
      { 
        (isActiveWidget === 'HARVEST')? (
      
          <div div className="pl16 mt10">
            <input
              className="w15"
              type="checkbox"
              id="sameHarvestDate"
              onChange={e => checked(e)}
              checked={isChecked}
            />
            <label htmlFor="sameHarvestDate">
           Use the same Harvest Date.
            </label>
          </div>
        ) : null }
    </Widget>
  )
}

export default HarvestSteward